/**
 *
 * invoiceDetails
 *
 */

import store from 'store';
import { Invoice } from './invoice';
import { Detection } from './detectInvoice';
import { getConfigFromStore } from './customerConfig';

/**
 * prediction details
 * NOTE: will be deprecated in favor of
 */
const customerConfig = getConfigFromStore();

export enum InvoicePredictionDetailType {
  DocumentType = 'DocumentType',
  InvoiceCurrency = 'InvoiceCurrency',
  InvoiceDate = 'InvoiceDate',
  InvoiceId = 'InvoiceId',
  GrandTotalAmount = 'GrandTotalAmount',
  CustomerId = 'CustomerId',
  SenderOrderId = 'SenderOrderId',
  ReceiverOrderId = 'ReceiverOrderId',
  DeliveryNoteId = 'DeliveryNoteId',
  SenderOrderDate = 'SenderOrderDate',
  ReceiverOrderDate = 'ReceiverOrderDate',
  DeliveryDate = 'DeliveryDate',
  Iban = 'Iban',
  KId = 'KId',
  IsrReference = 'IsrReference',
  IsrSubscriber = 'IsrSubscriber',
  SenderVatId = 'SenderVatId',
  ReceiverVatId = 'ReceiverVatId',
  NetTotalAmount = 'NetTotalAmount',
  VatTotalAmount = 'VatTotalAmount',
  //StrabagRefCode = 'StrabagRefCode',
  //OerkBezirksstelle = 'OerkBezirksstelle',
  VatGroup = 'VatGroup',
  VatRate = 'VatRate',
  NetAmount = 'NetAmount',
  VatAmount = 'VatAmount',
  DiscountGroup = 'DiscountGroup',
  DiscountDate = 'DiscountDate',
  DiscountDuration = 'DiscountDuration',
  DiscountPercent = 'DiscountPercent',
  DueDateGroup = 'DueDateGroup',
  DueDateDate = 'DueDateDate',
  DueDateDuration = 'DueDateDuration',
  BankGroup = 'BankGroup',
  BankCode = 'BankCode',
  BankAccount = 'BankAccount',
  VatId = 'UId',
  Sender = 'Sender', // DEPRECATED in favor of `InvoiceDetailType.Sender`
  LineItems = 'LineItemTable.LineItems',
  TotalAmount = 'TotalAmount',
}

export enum FirstInvoiceDetails {
  DocumentType = 'DocumentType',
  InvoiceCurrency = 'InvoiceCurrency',
  InvoiceDate = 'InvoiceDate',
  InvoiceId = 'InvoiceId',
  GrandTotalAmount = 'GrandTotalAmount',
  KId = 'KId',
  IsrReference = 'IsrReference',
  IsrSubscriber = 'IsrSubscriber',
}

export enum CustomerId {
  CustomerId = 'CustomerId',
}

export enum VatDetails {
  VatRate = 'VatRate',
  NetAmount = 'NetAmount',
  VatAmount = 'VatAmount',
}

export enum OtherDetails {
  SenderOrderId = 'SenderOrderId',
  ReceiverOrderId = 'ReceiverOrderId',
  DeliveryNoteId = 'DeliveryNoteId',
  SenderOrderDate = 'SenderOrderDate',
  ReceiverOrderDate = 'ReceiverOrderDate',
  DeliveryDate = 'DeliveryDate',
  Iban = 'Iban',
  SenderVatId = 'SenderVatId',
  ReceiverVatId = 'ReceiverVatId',
  NetTotalAmount = 'NetTotalAmount',
  VatTotalAmount = 'VatTotalAmount',
}

const customTypes: string[] = [];
if (customerConfig) {
  customerConfig.InvoiceDetails.forEach((detail) => {
    if (detail.InvoiceDetailTypeId === -2147483648) customTypes.push(detail.Name);
  });
}

const firstInvoiceDetails = Object.values(FirstInvoiceDetails);
const otherDetails: (OtherDetails | string)[] = Object.values(OtherDetails);

if (customerConfig) {
  customTypes.forEach((value) => {
    otherDetails.push(value);
  });
}

export function getInvoicePredictionDetailTypeFromInvoice(
  invoice: Invoice,
  type: InvoicePredictionDetailType,
): Detection | undefined {
  return invoice.DetectInvoiceResponse.InvoiceDetailTypePredictions.find(
    (prediction) => prediction.TypeName === type,
  );
}

export function getInvoicePredictionDetailTypeValueFromInvoice(
  invoice: Invoice,
  type: InvoicePredictionDetailType,
): string | undefined {
  const detail = getInvoicePredictionDetailTypeFromInvoice(invoice, type);
  if (!detail) {
    return undefined;
  }
  return detail.Value;
}

/**
 * details
 */

export enum InvoiceDetailType {
  Sender = 'Sender',
  Receiver = 'Receiver',
  AdditionalProperties = 'AdditionalProperties',
  Supplier = 'Supplier',
  Client = 'Client',
}

export enum InvoiceDetailContactType {
  Name = 'Name',
  Address = 'Address',
  WebsiteUrl = 'WebsiteUrl',
  Email = 'Email',
  Phone = 'Phone',
  Fax = 'Fax',
}
const invoiceDetailContactTypes = Object.values(InvoiceDetailContactType);

export enum InvoiceAdditionalPropertiesType {
  ClientId = 'ClientId',
  SenderEmail = 'SenderEmail',
  ReceiverEmail = 'ReceiverEmail',
}

const invoiceDetailAdditionalPropertiesTypes = Object.values(InvoiceAdditionalPropertiesType);

export enum InvoiceDetailSupplierType {
  SupplierId = 'SupplierId',
  Name = 'Name',
  Uids = 'Uids',
  Ibans = 'Ibans',
  City = 'City',
  Country = 'Country',
  Street = 'Street',
  ZipCode = 'ZipCode',
}

const invoiceDetailSupplierTypes = Object.values(InvoiceDetailSupplierType);

export enum InvoiceDetailClientType {
  Name = 'Name',
  Id = 'Id',
}

const invoiceDetailClientTypes = Object.values(InvoiceDetailClientType);

export enum InvoiceDetailContactAddressType {
  Street = 'Street',
  ZipCode = 'ZipCode',
  City = 'City',
  Country = 'Country',
}
// TODO-db-191014 implement sorting address types
// const invoiceDetailContactAddressTypes = Object.values(InvoiceDetailContactType);

/**
 * groups
 */

export const GROUP_TYPES = [InvoicePredictionDetailType.VatGroup, InvoiceDetailType.Sender, InvoicePredictionDetailType.LineItems];

export function isGroupType(
  type:
    | InvoicePredictionDetailType
    | InvoiceDetailType
    | InvoiceDetailContactType
    | InvoiceDetailContactAddressType,
) {
  return GROUP_TYPES.findIndex((groupType) => groupType === type) > -1;
}

/**
 * singular types
 *
 * They are types which cannot appear more then once on an invoice.
 */

// export const SINGULAR_TYPES = [
//   InvoicePredictionDetailType.DocumentType,
//   InvoicePredictionDetailType.VatRate,
//   InvoicePredictionDetailType.VatAmount,
//   InvoicePredictionDetailType.NetAmount,
//   InvoiceDetailType.Sender,
//   InvoiceDetailContactType.Name,
//   InvoiceDetailContactType.Address,
//   InvoiceDetailContactType.WebsiteUrl,
//   InvoiceDetailContactType.Email,
//   InvoiceDetailContactType.Phone,
//   InvoiceDetailContactType.Fax,
//   InvoiceDetailContactAddressType.Street,
//   InvoiceDetailContactAddressType.ZipCode,
//   InvoiceDetailContactAddressType.City,
//   InvoiceDetailContactAddressType.Country,
// ];

const singular: string[] = [];
if (customerConfig) {
  customerConfig.InvoiceDetails.forEach((element) => {
    if (!element.MultipleOccurrencesAllowed) singular.push(element.Name);
  });
}
//Hardcoded untill all the info
singular.push('AdditionalProperties');
singular.push('AdditionalProperties.ClientId');
singular.push('AdditionalProperties.SenderEmail');
singular.push('AdditionalProperties.ReceiverEmail');
singular.push('Supplier');
singular.push('Supplier.Name');
singular.push('Supplier.City');
singular.push('Supplier.Country');
singular.push('Supplier.Street');
singular.push('Supplier.ZipCode');
singular.push('Supplier.SupplierId');
singular.push('Client');
singular.push('Client.Name');
singular.push('Client.Id');

export const SINGULAR_TYPES = [...singular];

export function isSingularType(
  type:
    | InvoicePredictionDetailType
    | InvoiceDetailType
    | InvoiceDetailContactType
    | FirstInvoiceDetails
    | string
    | OtherDetails
    | InvoiceAdditionalPropertiesType
    | InvoiceDetailSupplierType
    | InvoiceDetailClientType
    | InvoiceDetailContactAddressType,
  path = '',
) {
  const pathSeperated = path.split('.');
  const nameWithDot = [];
  for (let i = 2; i < pathSeperated.length - 1; i++) nameWithDot.push(pathSeperated[i]);
  let namePath = nameWithDot.join('.');
  if (namePath[namePath.length - 1] === ']') namePath = namePath.slice(0, namePath.indexOf('['));
  if (type === 'TotalAmount')
    //return SINGULAR_TYPES.findIndex((groupType) => groupType === `LineItems.${type}`) > -1;
    return SINGULAR_TYPES.findIndex((groupType) => groupType === `LineItemTable.${type}`) > -1;
  if (type === 'NetAmount' || type === 'VatRate' || type === 'VatAmount')
    return SINGULAR_TYPES.findIndex((groupType) => groupType === `VatGroup.${type}`) > -1;
  if (type === 'DiscountDate' || type === 'DiscountDuration' || type === 'DiscountPercent')
    return SINGULAR_TYPES.findIndex((groupType) => groupType === `DiscountGroup.${type}`) > -1;
  if (type === 'DueDateDate' || type === 'DueDateDuration')
    return SINGULAR_TYPES.findIndex((groupType) => groupType === `DueDateGroup.${type}`) > -1;
  if (type === 'BankCode' || type === 'BankAccount')
    return SINGULAR_TYPES.findIndex((groupType) => groupType === `BankGroup.${type}`) > -1;
  if (
    nameWithDot[0] === 'Sender' ||
    nameWithDot[0] === 'Receiver' ||
    nameWithDot[0] === 'AdditionalProperties' ||
    nameWithDot[0] === 'Supplier' ||
    nameWithDot[0] === 'Client'
  )
    return SINGULAR_TYPES.findIndex((groupType) => groupType === namePath) > -1;
  else return SINGULAR_TYPES.findIndex((groupType) => groupType === type) > -1;
}

/**
 * deprecations
 */

// deprecated invoice prediction details which are superseded with field based invoice details
// const DEPRECATED_INVOICE_PREDICTION_DETAILS: Partial<
//   { [deprecatedPredictionDetail in InvoicePredictionDetailType]: InvoiceDetailType }
// > = {
//   [InvoicePredictionDetailType.Sender]: InvoiceDetailType.Sender,
// };

/**
 * ordering
 */

const INVOICE_DETAILS_ORDER_VERSION = '2';
export const INVOICE_DETAILS_ORDER_KEY = '@bludelta/invoiceDetailsOrder';

// some invoice details are customer specific and they should not be ordered!
// export const UNORDERABLE_INVOICE_DETAILS = [
//   InvoicePredictionDetailType.StrabagRefCode,
//   InvoicePredictionDetailType.OerkBezirksstelle,
// ];

// empty for now untill it's clear is StrabagRefCode and OerkBezirksstelle should stay in the code or not
export const UNORDERABLE_INVOICE_DETAILS = [];

export type InvoiceDetailTypesOrder = InvoiceDetailTypesOrderItem[];
export type MultiInvoiceDetailTypesOrder = InvoiceDetailTypesOrder[];

export interface InvoiceDetailTypesOrderItem {
  // TODO-db-191014 implement sorting `InvoiceDetailContactAddressType`
  type:
    | InvoicePredictionDetailType
    | InvoiceDetailType
    | InvoiceDetailContactType
    | InvoiceDetailSupplierType
    | string
    | FirstInvoiceDetails
    | OtherDetails
    | InvoiceDetailClientType
    | InvoiceAdditionalPropertiesType; // | InvoiceDetailContactAddressType
  items: InvoiceDetailTypesOrderItem[] | null;
}

export const defaultOrderableInvoiceDetailTypesOrder: MultiInvoiceDetailTypesOrder = [
  [
    ...firstInvoiceDetails.map((type) => {
      return {
        type,
        items: null,
      };
    }),
    {
      type: InvoicePredictionDetailType.VatGroup,
      items: [
        {
          type: InvoicePredictionDetailType.VatRate,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.NetAmount,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.VatAmount,
          items: null,
        },
      ],
    },
    {
      type: InvoicePredictionDetailType.DiscountGroup,
      items: [
        {
          type: InvoicePredictionDetailType.DiscountDate,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.DiscountDuration,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.DiscountPercent,
          items: null,
        },
      ],
    },
    {
      type: InvoicePredictionDetailType.DueDateGroup,
      items: [
        {
          type: InvoicePredictionDetailType.DueDateDate,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.DueDateDuration,
          items: null,
        },
      ],
    },
    {
      type: InvoicePredictionDetailType.BankGroup,
      items: [
        {
          type: InvoicePredictionDetailType.BankCode,
          items: null,
        },
        {
          type: InvoicePredictionDetailType.BankAccount,
          items: null,
        },
      ],
    },
    {
      type: InvoiceDetailType.Sender,
      items: invoiceDetailContactTypes.map((key) => ({
        type: InvoiceDetailContactType[key],
        items: null,
      })),
    },
    {
      type: InvoicePredictionDetailType.CustomerId,
      items: null,
    },
    {
      type: InvoiceDetailType.Receiver,
      items: invoiceDetailContactTypes.map((key) => ({
        type: InvoiceDetailContactType[key],
        items: null,
      })),
    },
    ...otherDetails.map((type) => {
      return {
        type,
        items: null,
      };
    }),
  ],
  [
    {
      type: InvoiceDetailType.Client,
      items: invoiceDetailClientTypes.map((key) => ({
        type: InvoiceDetailClientType[key],
        items: null,
      })),
    },
    {
      type: InvoiceDetailType.Supplier,
      items: invoiceDetailSupplierTypes.map((key) => ({
        type: InvoiceDetailSupplierType[key],
        items: null,
      })),
    },
  ],
];

export function saveOrderableInvoiceDetailTypesOrder(
  invoiceDetailsOrder: MultiInvoiceDetailTypesOrder,
) {
  const currentInvoiceDetailsOrderKey = INVOICE_DETAILS_ORDER_KEY + INVOICE_DETAILS_ORDER_VERSION;

  for(let i=0;i<2;i++){
    for(let j=0;j<invoiceDetailsOrder[i].length;j++){
      if(invoiceDetailsOrder[i][j].type==='AdditionalProperties'){
        invoiceDetailsOrder[i].splice(j, 1);
      }
    }
  }
  if (invoiceDetailsOrder) store.set(currentInvoiceDetailsOrderKey, invoiceDetailsOrder);
}

export function loadOrderableInvoiceDetailTypesOrder(): MultiInvoiceDetailTypesOrder | null {
  let invoiceDetailsOrder = null;
  const currentInvoiceDetailsOrderKey = INVOICE_DETAILS_ORDER_KEY + INVOICE_DETAILS_ORDER_VERSION;
  store.each((value, key) => {
    if (key === currentInvoiceDetailsOrderKey) invoiceDetailsOrder = value;
    if (key !== currentInvoiceDetailsOrderKey && key.indexOf(INVOICE_DETAILS_ORDER_KEY) > -1)
      store.remove(key);
  });
  return invoiceDetailsOrder;
}

export function getOrderableInvoiceDetailTypesOrder(): MultiInvoiceDetailTypesOrder {
  return loadOrderableInvoiceDetailTypesOrder() || defaultOrderableInvoiceDetailTypesOrder;
}

// export function getInvoiceDetailTypesOrder(): InvoiceDetailTypesOrder {
//   return [
//     ...UNORDERABLE_INVOICE_DETAILS.map((type) => ({
//       type,
//       items: null,
//     })),
//     ...getOrderableInvoiceDetailTypesOrder(),
//   ];
// }
export function getInvoiceDetailTypesOrder(): MultiInvoiceDetailTypesOrder {
  const order = getOrderableInvoiceDetailTypesOrder();
  for(let i=0;i<2;i++){
    for(let j=0;j<order[i].length;j++){
      if(order[i][j].type==='AdditionalProperties'){
        order[i].splice(j, 1);
      }
    }
  }
  order[0] = [
    {
      type: InvoiceDetailType.AdditionalProperties,
      items: invoiceDetailAdditionalPropertiesTypes.map((key) => ({
        type: InvoiceAdditionalPropertiesType[key],
        items: null,
      })),
    },
    ...order[0],
    ...UNORDERABLE_INVOICE_DETAILS.map((type) => ({
      type,
      items: null,
    })),
  ];
  return order;
}
